var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PublicColescbaApp',{attrs:{"app-container-classes":"md:p-6","router-view-classes":"container mx-auto xl:w-5/6"}})
}
var staticRenderFns = []

export { render, staticRenderFns }